module.exports = __webpack_public_path__ + "static/img/job-header-default.29bba8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-header-default.png
// module id = hRxm
// module chunks = 7